import IconButton from '@material-ui/core/IconButton';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import { default as DeleteIcon } from '@material-ui/icons/Close';
import React from 'react';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableHead: {
      backgroundColor: 'inherit'
    },
    actionsTableCellContent: {
      display: 'flex',
      alignItems: 'center'
    },
    flex: {
      flex: 1
    }
  })
);

interface Props {
  paramSets: any[];
  accountId: string;
  region: string;
  onParamSetsChange: (paramSets: any) => void;
}

function ActionParamSetListInput(props: Props) {
  const { paramSets, accountId, region, onParamSetsChange } = props;
  const classes = useStyles({});

  const onRemoveParamSet = (paramSet) => {
    const paramSetsCopy = paramSets.slice();
    paramSetsCopy.splice(paramSetsCopy.indexOf(paramSet), 1);
    onParamSetsChange(paramSetsCopy);
  };

  const onEditParamSet = (paramSet) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const paramSetsCopy = paramSets.slice();
    const index = paramSetsCopy.indexOf(paramSet);
    paramSetsCopy[index] = { ...paramSet, [event.target.name]: event.target.value };
    onParamSetsChange(paramSetsCopy);
  };

  return (
    <TableContainer>
      <Table size="small">
        <TableHead className={classes.tableHead}>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Version</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {paramSets.map((paramSet, index) => <TableRow key={index} >
            <TableCell>
              <TextField
                name="name"
                onChange={onEditParamSet(paramSet)}
                fullWidth
                placeholder="name"
                value={paramSet.name}
              />
            </TableCell>
            <TableCell>
              <TextField
                name="version"
                onChange={onEditParamSet(paramSet)}
                fullWidth
                placeholder="version"
                value={paramSet.version}
              />
            </TableCell>
            <TableCell>
              <div className={classes.actionsTableCellContent}>
                {accountId && region && paramSet.name && paramSet.version && <Link
                  variant="body1"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/faro/parameters/${accountId}/${region}/${paramSet.name}?version=${paramSet.version}`}
                >
                  View
                </Link>}
                <span className={classes.flex} />
                <IconButton onClick={() => onRemoveParamSet(paramSet)}><DeleteIcon /></IconButton>
              </div>
            </TableCell>
          </TableRow>)}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ActionParamSetListInput;
